import { render, staticRenderFns } from "./SelectVoucherPage.vue?vue&type=template&id=196a53b8&scoped=true&"
import script from "./SelectVoucherPage.vue?vue&type=script&lang=js&"
export * from "./SelectVoucherPage.vue?vue&type=script&lang=js&"
import style0 from "./SelectVoucherPage.vue?vue&type=style&index=0&id=196a53b8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196a53b8",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QField from 'quasar/src/components/field/QField.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QIcon,QInput,QField});qInstall(component, 'directives', {ClosePopup});
